import { useSelector } from "react-redux";
import { AppState } from "store";
import { useSalaryPermissions } from "components/salary";

function useEarlyPayoutPermissions() {
  const { isSalaryAdmin } = useSalaryPermissions();
  const { wintSalaryCompanySettings } = useSelector((state: AppState) => state.auth.selectedCompany);
  const grossSalaryChangeEnabled = wintSalaryCompanySettings?.grossSalaryChangeEnabled ?? false;
  const canCreateEarlyPayout = isSalaryAdmin && grossSalaryChangeEnabled;

  return { canCreateEarlyPayout };
}

export default useEarlyPayoutPermissions;
